import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './App.css';
import App from "./App";
import { HistoryProvider } from "./context/HistoryContext";
import { ThemeProviderWrapper } from "./components/GeneralConfig"; // Certifique-se do caminho correto
import * as serviceWorker from './serviceWorker.js';
import "../src/home/NewHome.jsx";
// import "../src/home/styles/NewHome.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <ThemeProviderWrapper>
      <BrowserRouter>
        <HistoryProvider>
          <App />
        </HistoryProvider>
      </BrowserRouter>
    </ThemeProviderWrapper>
  // </React.StrictMode>,
  // document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

